export default __webpack_public_path__ + "static/media/recurring.2f312532.svg";